// extracted by mini-css-extract-plugin
export default {"container":"index_container__kt1VA"};